import gCard from "@/components/g-card/g-card.vue"
import gForm from "@/components/g-form/g-form.vue"
import FiltroGerenciarTransportadora from "@/shared/view-models/Filtros/FiltroGerenciarTransportadora";
import CidadeController from "@/shared/controllers/cidade/cidadeController";
import EstadoController from "@/shared/controllers/estado/estadoController";
import Tools from "@/shared/services/tools";

import {mask} from 'vue-the-mask'
import TransportadoraController from "@/shared/controllers/transportadora/transportadoraController";

export default {
  name:'GerarNovaTransportadora',
  directives: {mask},
  components: { 
    gCard,
    gForm
   
  }, 

  props: { },

  mounted () {
    this.EstadoArray = EstadoController.getEstados().EstadosArray;
    this.EmpresaArray = this.$store.state.EmpresaArray;

   },

  updated () { },

  data () {
    return {
      EmpresaArray: [],
      EstadoArray: [],
      CidadeArray: [],
      TransportadoraViewModel: new FiltroGerenciarTransportadora,
    }
  },

  methods: {
    setCidade () {
      let cidade = this.CidadeArray.find((Element) => Element.id == this.TransportadoraViewModel.CidadeId)
      let estado = this.EstadoArray.find((Element) => Element.id == cidade.estadoId)
  
      if(estado)
        this.TransportadoraViewModel.EstadoId = estado.id
  
    },
    buscarCidadeSemEstado(event){

      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.CidadeArray = CidadeController.getByCidadeEstado(event).CidadeArray;
      }, 1000);
    },
    popularDropDownEstado(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + 'Estado/get',
      })
        .then((response) => {
          this.EstadoArray = response.data.data
  
        })
        .catch(() => {
        });
    },
    buscarcidade(){
      this.axios({
          method: 'post',
          url: process.env.VUE_APP_WEB_API + 'Cidade/getbyestado',
          data: {
              id: this.TransportadoraViewModel.EstadoId
          }
        })
          .then((response) => {
            this.CidadeArray = response.data.data


          })
          .catch(() => {
          });
    },
    verificaCPNJ() {
      if(this.TransportadoraViewModel.Cnpj.length == 18) {
        var cnpjValido = Tools.validaCNPJ(this.TransportadoraViewModel.Cnpj)
        if (!cnpjValido) {
          this.$toast.add({ severity: 'error', summary: 'CNPJ invalido', life: 5000 });
        }
      }  
    },
    voltar(){
      this.$router.push(`/gerenciamento-transportadoras`)
    },
    novaTransportadora() {
      this.$router.push(`/gerar-nova-transportadora`)
    },
    valida() {
      if(this.TransportadoraViewModel.Cnpj == (null || undefined)) {
        this.$toast.add(
          {
            severity:'error', 
            summary: 'ERRO', 
            detail:"O campo CNPJ é obrigatório", 
            life: 3000
          })
      }
      if(this.TransportadoraViewModel.Cep == (null || undefined)) {
        this.$toast.add(
          {
            severity:'error', 
            summary: 'ERRO', 
            detail:"O campo CEP é obrigatório", 
            life: 3000
          })
      }
      if(this.TransportadoraViewModel.NomeTransportadora == (null || undefined)) {
        this.$toast.add(
          {
            severity:'error', 
            summary: 'ERRO', 
            detail:"O campo Nome Transportadora é obrigatório", 
            life: 3000
          })
      }
      if(this.TransportadoraViewModel.EstadoId == (null || undefined)) {
        this.$toast.add(
          {
            severity:'error', 
            summary: 'ERRO', 
            detail:"O campo Estado é obrigatório", 
            life: 3000
          })
      }
      if(this.TransportadoraViewModel.CidadeId == (null || undefined)) {
        this.$toast.add(
          {
            severity:'error', 
            summary: 'ERRO', 
            detail:"O campo Cidade é obrigatório", 
            life: 3000
          })
      }
      if(this.TransportadoraViewModel.Endereco == (null || undefined)) {
        this.$toast.add(
          {
            severity:'error', 
            summary: 'ERRO', 
            detail:"O campo Endereço é obrigatório", 
            life: 3000
          })
      }
      if(this.TransportadoraViewModel.Bairro == (null || undefined)) {
        this.$toast.add(
          {
            severity:'error', 
            summary: 'ERRO', 
            detail:"O campo CNPJ é obrigatório", 
            life: 3000
          })
      }
      else {
        this.gerarTransportadora();
      }

    },
    gerarTransportadora(){
      TransportadoraController.postTransportadora(this.TransportadoraViewModel).requisicao
      // .then((res => {
      // }))
    }
  },

  computed: { }, 

};